import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import "./style.scss";
import { MenuItem } from "../../@types/stores/menu";
import MenuItemBlock from "../../components/MenuItem";
import { useParams } from "react-router";
import menuStore from "../../stores/menu";
import Footer from "../../components/Footer";
import OrderIdle from "../../components/OrderIdle";

const RecommendationItemPage = () => {
    const params = useParams();

    const [item, setItem] = useState<MenuItem>();

    useEffect(() => {
        const groupId = params.groupId && !isNaN(+params.groupId) ? +params.groupId : 0;
        getItem(groupId, params.number);
    }, [params]);

    const getItem = async (groupId: number, number: string | undefined) => {
        if (number) {
            const _item = menuStore.getRecommendationItemByNumber(groupId, number);
            if (_item) {
                setItem(_item);
            }
        }
    }

    return <div className="RecommendationItemPage">
        <Header />
        {item
            ? <MenuItemBlock item={item} skipRecommendations={true} recommendationGroupId={+(params.groupId || 0)} />
            : null
        }
        <Footer showBack={true} skipRecommendations={true} />
        <OrderIdle />
    </div>
}

export default RecommendationItemPage;